/**
 * Web Membership Reconciliation entry decision (ADR 0018).
 *
 * After login the web app calls the `reconcilePendingTeamMemberships` callable,
 * which returns the teams the Caller was just auto-joined to. This pure helper
 * decides what the UI does next — auto-enter the one obvious team, show a picker
 * when there's a real choice, or do nothing. Membership is already established
 * server-side; this only chooses the active Account Selection.
 */

export interface ReconciledTeam {
	teamId: string;
	teamName: string | null;
}

export type ReconcileEntryDecision =
	| { action: 'none' }
	| { action: 'enter'; teamId: string; teamName: string | null }
	| { action: 'picker'; teams: ReconciledTeam[] };

export function decideReconcileEntry (
	reconciledTeams: ReconciledTeam[],
	hasOtherTeams: boolean,
): ReconcileEntryDecision {
	const teams = reconciledTeams || [];
	if (teams.length === 0) {
		return { action: 'none' };
	}
	// Exactly one newly-joined team and nothing else to choose between → drop them
	// straight in (zero-click). Anything ambiguous falls through to the picker.
	if (teams.length === 1 && !hasOtherTeams) {
		return { action: 'enter', teamId: teams[0].teamId, teamName: teams[0].teamName };
	}
	return { action: 'picker', teams };
}
